module.exports = __webpack_public_path__ + "plane-pc/img/ma_i.3ea913c7.png";